<template>
  <div class="mpn-infobox">
    <p
      v-for="(message, index) in computedMsgs"
      :key="index"
      v-html="toHtml(message)"
    />
    <p class="gap" />
    <mpn-basic-button @click="onClickConfirm">
      확인
    </mpn-basic-button>
  </div>
</template>
<script>
export default {
  name: 'InfoBox',
  props: {
    msg: {
      type: String,
      default: '<경고 메시지>',
    },
    msgs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    computedMsgs() {
      if (this.msgs.length > 0) {
        return this.msgs;
      }
      return [this.msg];
    },
  },
  methods: {
    onClickConfirm() {
      this.$emit('dispose');
    },
    toHtml(msg) {
      return msg.replace(/\n/g, '<br>');
    },
  },
};
</script>
<style scoped>
.mpn-infobox {
  width:100%;
  padding:30px 15px 30px 15px;
  background:#fff;
  border-radius:20px;
  box-shadow:0 1px 10px 0 rgba(0, 0, 0, 0.1);
  font-size:18px;
  line-height:24px;
  color:#073463;
  text-align:center;
}

.mpn-infobox button {
  margin-top: 20px;
}
.mpn-infobox p {
  margin-top: 10px;
}

</style>
